module.exports = __webpack_public_path__ + "img/pusat_panduan.7f0f0f8a.svg";